import { translate } from "./translate";
import { Buffer } from 'buffer';

export async function getBase64(base64String = '', pureBase64 = false, placeholderImg = 'img/icon.webp'){
  if(base64String == '' || base64String == null){
    if(pureBase64)
      return await fetchImageAsBase64(`${process.env.VUE_APP_BASE_URL}${placeholderImg}`);
    return `url(${process.env.VUE_APP_BASE_URL}${placeholderImg})`;
  }
  if(pureBase64)
    return `data:image/png;base64,${base64String}`;
  return `url(data:image/png;base64,${base64String})`;
}

export async function getOnPublicImagesUrl(fileName = '', defaultImage = 'img/icon.webp'){
    let requestedUrl = `${process.env.VUE_APP_BASE_URL}${fileName}`;
    const result = await resourceExists(requestedUrl);
    if(result){
        return requestedUrl;
    }else{
        return `${process.env.VUE_APP_BASE_URL}${defaultImage}`;
    }
}

export async function fetchImageAsBase64(url) {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const reader = new FileReader();

      return new Promise((resolve, reject) => {
        reader.onloadend = () => {
          resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.error("Erro ao buscar a imagem:", error);
      return null;
    }
}

export function getOnPublic(fileName = ''){
    return `${process.env.VUE_APP_BASE_URL}${fileName}`;
} 

export async function resourceExists(url) {
    try {
      const response = await fetch(url, { method: 'HEAD' });
      if(!response.ok)
        console.clear();
      return response.ok;
    } catch (error) {
      return false;
    }
}

export function isImageValid(file){
    let response = {
        status: false,
        message: 'error'
    }
    const allowedMimeTypes = ['image/jpeg', 'image/png', 'image/gif'];
    if (!allowedMimeTypes.includes(file.type)) {
        response.message = translate('accepted formats are: JPEG, PNG and GIF', 'ucfirst');
        return response;
    }
    const maxSizeInBytes = 2 * 1024 * 1024; // 2 MB
    if (file.size > maxSizeInBytes) {
        response.message = translate('max allowed size is 2 MB', 'ucfirst');
        return response;
    }
    response.status = true;
    return response;
}

export function isBase64(str = '') {
  if (!str || typeof str !== 'string' || str.length % 4 !== 0) {
    return false;
  }

  try {
    const decoded = Buffer.from(str, 'base64');
    const reEncoded = decoded.toString('base64');

    const base64Regex = /^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/;
    if (reEncoded === str) {
        return base64Regex.test(str);
    }
    
    return false;
  } catch (e) {
    return false;
  }
}